/* eslint-disable @nx/enforce-module-boundaries */
import { Injectable } from '@angular/core';
import { DroppedWidgetIntoLayoutWidgetAction } from '@app/finxone-web-frontend/app/lib/actions/dropped.action';
import { UpdateGridLayout } from '@app/finxone-web-frontend/app/lib/actions/grid.action';
import { WidgetLayoutPosition } from '@app/finxone-web-frontend/app/lib/services/account-service/account.type';
import {
  ActiveConfig,
  LayoutNames,
  NewUiZoneWidgetConfig,
  WorkflowWidgetConfig,
} from '@finxone-platform/shared/sys-config-types';
import { Actions, Store, ofActionDispatched } from '@ngxs/store';
import { DragStartAction, DroppedWidgetAction } from '../../actions/app-grid.action';
import { ActiveConfigService } from '../active-config/active-config.service';
import { WorkflowEditorService } from '../workflow-editor/workflow-editor.service';

@Injectable({
  providedIn: 'root',
})
export class AppBuilderAdapterService {
  activeConfig: ActiveConfig;
  private _droppedStatus = false;

  constructor(
    private activeConfigService: ActiveConfigService,
    // private appBuilderService: AppBuilderService,
    private newAppBuilderService: WorkflowEditorService,
    private actions$: Actions,
    private store: Store,
  ) {
    this.activeConfigService.getConfig().subscribe((activeConfig) => {
      this.activeConfig = activeConfig;
    });

    this.actions$.pipe(ofActionDispatched(UpdateGridLayout)).subscribe((action) => {
      this.updateWidgetPosition(action.layoutPositionUpdates.layouts);
    });
  }

  dragStart(data: WorkflowWidgetConfig) {
    this.setDroppedStatus(false);
    this.store.dispatch(new DragStartAction(data)); // Can be used by old and new app builder
  }

  dragEnd() {
    console.log('dragEnd');
    this.setDroppedStatus(true);
  }

  droppedIntoMain(widgetLayoutType?: LayoutNames | string | undefined) {
    if (!this.getDroppedStatus()) {
      console.log('drop main');
      this.setDroppedStatus(true);
      this.store.dispatch(new DroppedWidgetAction(widgetLayoutType));
    }
  }

  droppedIntoWidget(widgetDroppedInto: NewUiZoneWidgetConfig) {
    if (!this.getDroppedStatus()) {
      console.log('drop widget');
      this.setDroppedStatus(true);
      this.store.dispatch(new DroppedWidgetIntoLayoutWidgetAction(widgetDroppedInto));
    }
  }

  getDroppedStatus() {
    return this._droppedStatus;
  }

  setDroppedStatus(status: boolean) {
    this._droppedStatus = status;
  }

  getCurrentPageWidgets(): WorkflowWidgetConfig[] {
    return this.newAppBuilderService.getCurrentPageWidgets();
  }

  updateWidgetPosition(layout: WidgetLayoutPosition[]): boolean {
    this.newAppBuilderService.updateWidgetPosition(layout);
    return true;
  }
}
